import {
  createFileRoute,
  Outlet,
  Link,
  useLocation,
} from "@tanstack/react-router";
import { useTenant } from "../lib/tenant-context";
import { useEffect } from "react";

export const Route = createFileRoute("/warehouse")({
  component: WarehouseLayout,
});

function WarehouseLayout() {
  const { tenantId } = useTenant();
  const location = useLocation();

  // Redirect tenants without warehouse access
  const warehouseTenants = ["nespresso", "adidas"];
  useEffect(() => {
    if (!warehouseTenants.includes(tenantId || "")) {
      window.location.href = "/";
    }
  }, [tenantId]);

  if (!warehouseTenants.includes(tenantId || "")) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <p className="text-gray-500">
          This feature is not available for this tenant.
        </p>
      </div>
    );
  }

  const isActive = (path: string) => {
    if (path === "/warehouse" && location.pathname === "/warehouse") {
      return true;
    }
    return path !== "/warehouse" && location.pathname.startsWith(path);
  };

  return (
    <div>
      {/* Warehouse Sub-navigation */}
      <div
        className="mb-6 border-b"
        style={{ borderColor: "rgba(169,169,169,0.2)" }}
      >
        <div className="flex gap-1">
          <SubNavLink
            to="/warehouse"
            icon={<ListIcon />}
            label="Packages"
            isActive={
              isActive("/warehouse") && !location.pathname.includes("/overview")
            }
          />
          <SubNavLink
            to="/warehouse/overview"
            icon={<DashboardIcon />}
            label="Overview"
            isActive={isActive("/warehouse/overview")}
          />
        </div>
      </div>

      {/* Nested route content */}
      <Outlet />
    </div>
  );
}

function SubNavLink({
  to,
  icon,
  label,
  isActive,
}: {
  to: string;
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
}) {
  return (
    <Link
      to={to}
      className="flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors border-b-2 -mb-[2px]"
      style={
        isActive
          ? {
              color: "#171717",
              borderColor: "#6B4423",
            }
          : {
              color: "#A9A9A9",
              borderColor: "transparent",
            }
      }
    >
      {icon}
      {label}
    </Link>
  );
}

function ListIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path
        d="M8 6H21M8 12H21M8 18H21"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6H3.01M3 12H3.01M3 18H3.01"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DashboardIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <rect
        x="3"
        y="3"
        width="7"
        height="7"
        rx="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="14"
        y="3"
        width="7"
        height="7"
        rx="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="14"
        y="14"
        width="7"
        height="7"
        rx="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="3"
        y="14"
        width="7"
        height="7"
        rx="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
